export default __webpack_public_path__ + "static/google-seznam-banner-8cf09b90daaeefb24ea3f9979db18730.png";